import React, { useMemo } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import {
  useToggle,
  CoreModal,
  CorePage,
  CorePageTitle,
  PageableFilterSearchTable,
} from '@amzn/dots-core-ui';
import { Configuration, PackageType, useClient } from '../../api';
import ConfigurationColumnDefinitions, {
  ConfigurationColumnDefinitionFilters,
} from './ConfigurationColumnDefinitions';
import { PackageForm } from '../Packages';
import Row from '@amzn/meridian/row';
import Tooltip from '@amzn/meridian/tooltip';
import Button from '@amzn/meridian/button';

const ConfigurationList = ({
  title,
  packageType,
}: {
  title: string;
  packageType: PackageType;
}): JSX.Element => {
  const tableKey = `filter-table-${packageType}`;
  const history = useHistory();
  const { path } = useRouteMatch();
  const [isModalOpen, closeModal, openModal] = useToggle();
  const { tmsClient } = useClient();

  const filterFields = useMemo(
    () =>
      packageType === 'test'
        ? ConfigurationColumnDefinitionFilters
        : ConfigurationColumnDefinitionFilters.filter(
            (e) => e.key !== 'config' && e.key !== 'default'
          ),
    [packageType]
  );

  return (
    <>
      <CoreModal
        title={`Add a new ${packageType}`}
        isOpen={isModalOpen}
        onClose={closeModal}
      >
        <PackageForm
          onCancel={closeModal}
          onSubmit={async (newPackage): Promise<void> => {
            const result = await tmsClient.packages.create({
              ...newPackage,
              type: packageType,
            });
            history.push(`${path}/${result.id}/suites`);
          }}
        />
      </CoreModal>
      <CorePage
        title={title}
        header={
          <Row widths="fill">
            <CorePageTitle title={title} />
          </Row>
        }
      >
        <PageableFilterSearchTable
          key={tableKey}
          actions={
            <Row alignmentHorizontal="end">
              <Tooltip title="Add New" position="bottom">
                <Button onClick={openModal}>Add New</Button>
              </Tooltip>
            </Row>
          }
          resourceKey={tmsClient.configurations.resourceKey}
          getAll={tmsClient.configurations.getAll}
          resourceFilters={filterFields}
          preSetParams={{ fuzzySearch: false, packageType }}
          columns={ConfigurationColumnDefinitions}
          onRowClick={(item: Configuration): void =>
            history.push(
              `${path}/${item.packageId}/${
                packageType === 'test' ? `suites#${item.name}` : 'versions'
              }`
            )
          }
        />
      </CorePage>
    </>
  );
};
export default ConfigurationList;
